import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AssistantInstructionsComponent } from './components/assistant-instructions/assistant-instructions.component';
import { AdvancedInstructionsPopupComponent } from './components/advanced-instructions-popup/advanced-instructions-popup.component';

@NgModule({
  declarations: [AssistantInstructionsComponent, AdvancedInstructionsPopupComponent],
  imports: [SharedModule],
  exports: [AssistantInstructionsComponent, AdvancedInstructionsPopupComponent],
})
export class AssistantInstructionsModule {}
